import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from '../../../components/ModalSheet'
import { RemoveFromWorkspaceViewModel } from './RemoveFromWorkspaceViewModel'
import Button from '../../../components/Button'
import { TextInputContainer } from 'components/inputs'

interface Props {
  vm: RemoveFromWorkspaceViewModel
}

const RemoveFromWorkspaceDialog = observer(function ({ vm }: Props) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            Remove user{vm.selectedUserIds.length > 1 ? <>s</> : null} from this
            workspace
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            This action will remove{' '}
            {vm.selectedUser ? (
              <b> {vm.selectedUser.displayName} </b>
            ) : (
              <b> {vm.selectedUserIds.length} users </b>
            )}{' '}
            from the <b>{vm.workspace.name}</b> workspace. Are you sure you want
            to proceed?
          </ModalSheetContentDescription>
          <ModalSheetSection>
            <TextInputContainer
              autoFocus
              label="Type this word: remove"
              field="confirmation"
              model={vm}
              data-test="user-management-remove-from-workspace-remove-input"
              error={vm.validation.getError('confirmation')}
            />
          </ModalSheetSection>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="danger"
            data-test="user-management-remove-from-workspace-remove-button"
            onClick={vm.submit}
            disabled={vm.submit.pending}
            loading={vm.submit.pending}
          >
            {vm.selectedUser
              ? 'Remove user'
              : `Remove ${vm.selectedUserIds.length} users`}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

export default RemoveFromWorkspaceDialog
